import { createRequestInterceptor, Notification, NotificationRef } from 'medere-ui-framework';
import axios from 'axios';
import { useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from "firebase/messaging";
import AppRouteComponents from './components/AppRouteComponents/AppRouteComponents';
import './App.css'
import 'primeicons/primeicons.css';
import "medere-ui-framework/dist/style.css"
import ProfessionalData from './components/context/RecipeProfessionalDataContext';
import { useSelector } from 'react-redux';
import { RootState } from './redux/store';
import { useVersionCheck } from './hooks/useVersionCheck';
import { fireBaseConfig } from './utils/firebaseConfig';

export const axiosInstance = axios.create({ withCredentials: true })

axios.interceptors.request.use(createRequestInterceptor(axios));
axiosInstance.interceptors.request.use(createRequestInterceptor(axiosInstance));

//inicializar Firebase
initializeApp(fireBaseConfig);
export const messaging = getMessaging();

export const onMessageListener = () => new Promise((resolve) => onMessage(messaging, (payload: any) => resolve(payload)));

export default function App() {
  const notificationRef = useRef<NotificationRef>(null);
  const notification = useSelector((state: RootState) => state.general.notification);
  useEffect(() => { notification && notificationRef?.current?.notify(notification) }, [notification]);
  useVersionCheck(60000);
  useEffect(() => {
    window.addEventListener('logoutRequired', () => { });
    return () => { window.removeEventListener('logoutRequired', () => { }) };
  }, []);

  window.addEventListener('storage', event => {
    event.key == "logout" && (window.location.pathname = "/login");
    event.key == "login" && (window.location.pathname = "/");
  });

  return (
    <div className="App scrollbar">
      <ProfessionalData>
        <AppRouteComponents />
      </ProfessionalData>
      <Notification ref={notificationRef} />
    </div>)
}
